module.exports = __webpack_public_path__ + "static/media/newton-country-day.28c6fca3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/logos/newton-country-day.jpg
// module id = 626
// module chunks = 0